import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import GoogleReader from "../components/reader"
import ScrollTop from "../components/scroll-top"

import { CtxProvider } from "../context"

import "./index.css"

const IndexPage = (props) => {
  const { data } = props
  const { urlApi, searchString } = data.site.siteMetadata

  // - la searchString ici est purement décorative ! ne correspond pas à la recherche réelle
  // qui est gérée par l'API
  // - on passe "location" au context pour récupérer d'eventuel `location.state.var` qui aurait
  // été passé dans les props d'un <Link>. voir <Sorter> et le passage du `filterSite` en cours
  const searchArray = searchString.split("+")
  return (
    <CtxProvider
      initialeUrlApi={urlApi}
      initialSortBy="insertedDate"
      location={props.location}
    >
      <Layout>
        <SEO title="Makers et Fablabs se mobilisent !" />
        <GoogleReader
          searchArray={searchArray}
          placeholderSrc={data.placeholderImage.childImageSharp.fluid.src}
          initialeUrlApi={urlApi}
        />
        <ScrollTop />
      </Layout>
    </CtxProvider>
  )
}

export const query = graphql`
  {
    site {
      siteMetadata {
        searchString
        urlApi
      }
    }
    placeholderImage: file(relativePath: { eq: "placeholder.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          src
        }
      }
    }
  }
`

export default IndexPage
